module.exports = __webpack_public_path__ + "img/z智能监护.ca233036.png";